import { render, staticRenderFns } from "./ImtCalc.vue?vue&type=template&id=f1529fbe"
import script from "./ImtCalc.vue?vue&type=script&lang=js"
export * from "./ImtCalc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports